export default __webpack_public_path__ + "static/media/distanstolkning8.25000839.png";